import { Chip, Paper, Stack, Typography } from "@mui/material";
import { useMutation, useQuery, useQueryClient } from "react-query";
import API from "../../../services/API";
import { LoadingButton } from "@mui/lab";
import { Clear, Speed } from "@mui/icons-material";
import moment from "moment";

export default function Sponsor({ person }) {
    const queryKey = ['sponsor', person.id];

    const queryClient = useQueryClient();

    const { data: counter, isSuccess, isFetching } = useQuery({
        queryKey: queryKey,
        queryFn: async () => {
            const response = await API.get(`/crm/users/${person.id}/sponsor/count`);
            return response.data;
        },
    });

    const { mutate: resetCounter, isPending } = useMutation({
        mutationFn: async () => {
            const ok = window.confirm("Êtes vous sûr de vouloir réinitialiser le compteur de parrainage ?");
            if (!ok) return counter;
            const response = await API.put(`/crm/users/${person.id}/sponsor/reset`);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(queryKey);
        }
    });

    if (!isSuccess) return <></>;

    return (
        <Paper variant="outlined" sx={{ p: 1 }}>
            <Stack gap={1}>
                <Typography>Crédits de parrainage :</Typography>
                <Stack direction="row" alignItems="center" gap={1}>
                    <Chip 
                        icon={<Speed />}
                        color="primary" 
                        label={`${counter?.count ?? 0} point${counter?.count === 1 ? '' : 's'}`}
                    />
                    {(counter?.count ?? 0) > 0 && 
                        <LoadingButton 
                            startIcon={<Clear />} 
                            onClick={() => resetCounter()} 
                            loading={isPending || isFetching}
                            disabled={(counter?.count ?? 0) < 1}
                            color="error"
                        >
                            Réinitialiser
                        </LoadingButton>
                    }
                </Stack>
                {counter?.resetAt &&
                    <Typography variant="body2" color="text.secondary">
                        Compteur réinitialisé le {moment(counter?.resetAt).toDate().toLocaleDateString()}
                    </Typography>
                }
            </Stack>
        </Paper>
    );
}